<template>
  <v-card class="mb-12 rich-text">
    <v-card-text>
      <h1>Data Protection</h1>
      <p>
        We want you to understand how we use and look after your personal information and personal
        information about other people that is (or could be) contained in the digital materials you give to us.
      </p>

      <h2 class="mt-6">
        Your personal information
      </h2>
      <p>We use your personal information</p>
      <ul>
        <li>To fulfil legal obligations (like protecting copyright)</li>
        <li>
          To pursue our legitimate interests which include
          <ul>
            <li><em>keeping records of the provenance of archival material</em></li>
            <li><em>improving and developing our collections and services</em></li>
            <li><em>maintaining contact with depositors of archival material</em></li>
          </ul>
        </li>
        <li>To deliver our contractual obligations to you as a user of our service</li>
      </ul>

      <h2 class="mt-6">
        Personal information about other people
      </h2>
      <p>The digital materials you give to us may contain personal information about you and about other people.</p>
      <p>This personal information could have been created or acquired by you or by the organisation that accumulated the digital materials.</p>
      <p>
        This personal information will be handled according to the safeguards in data protection legislation for
        <b>archiving in the public interest</b>. Cambridge University Libraries preserves its collections for long term public benefit.
        It is permitted to process personal data (including special category data) where necessary for archiving purposes in the public interest.
        The National Archives website includes guidance about
        <a
          href="https://www.nationalarchives.gov.uk/archives-sector/legislation/archives-data-protection-law-uk/"
          target="_blank"
          rel="noopener noreferrer"
        >data protection legislation</a> as applied to archives in the UK.
      </p>
    </v-card-text>
  </v-card>
</template>

<script>
import '@/styles/rich-text.css'

export default {
  name: 'DataProtection',
}
</script>
